import { Box, Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import StelModal from "../../StelModal";

export default function ChoicesModal(props) {
  const { onClose, onConfirm, message, isDisplayed, title, width } = props;

  return (
    <StelModal open={isDisplayed} onClose={onClose} title={title} width={width}>
      <Box>
        <Typography
          variant="body2"
          sx={{
            textAlign: "center",
          }}
        >
          {message}
        </Typography>
        <Box
          sx={{
            textAlign: "center",
          }}
        >
          <Button
            color="error"
            variant="outlined"
            sx={{ marginRight: "16px" }}
            onClick={() => onClose()}
          >
            No
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => onConfirm()}
          >
            Yes
          </Button>
        </Box>
      </Box>
    </StelModal>
  );
}

ChoicesModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  isDisplayed: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.number,
};

ChoicesModal.defaultProps = {
  width: 450,
};
